import React,{useState} from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate } from 'react-router-dom'
import {facultyposlists} from '../../../apis/urls'
import axios from "axios";

const AddFacultyPosition = () => {

    const [name,setName] = useState('');
    const [description,setDescription] = useState('');
    const [status,setStatus] = useState('');
    const [nameerror,setNameerror] = useState(false);
    const [existname,setExistname] = useState(false);
    const [publicvalue,setPublicvalue] = useState('');

    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/facultyposlist")
        
    }


    const onFormClick = () => {

        let error = 0;
        console.log("namaValue",name)

        if(name === '')
        {
            
            setNameerror(true)
            error = 1;
        }else{
          
            setNameerror(false)
            error = 0;
        }

        if(error === 0) 
        {

            let token = "Bearer "+localStorage.getItem('token');
            console.log(token)
            const data = {
                name :name,
                description :description,
                status :status || 'ACTIVE',
                public:publicvalue||'NO'
            }
            
            const instance = axios.create({

                baseURL: facultyposlists,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{
                
                let path = 'newPath'; 
                navigate("/facultyposlist")
            
            }).catch((error) =>{
                
                console.log('error',error.response.data.error[0].name)

                if(error.response.data.error[0].name === 'Faculty position name is already in use!')
                {
                    setExistname(true)
                }

                
                

            });
        }



    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add New Faculty Position</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/facultyposlist">Faculty Positions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Faculty Position</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="card formcard small">
                            <div className="card-body">
                                <div className="form-group">
                                    <label className="degreehead">Position Name <span style={{color: "red"}}>*</span></label>
                                    <input type="text" className="form-control bg-dark dark-theme showtext" value={name} onChange={e => {setName(e.target.value)}} placeholder="Enter Position" id="name"></input>
                                    {
                                       nameerror
                                       ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Position</div>
                                       :null
                                    }
                                    {
                                        existname?
                                        <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Faculty position name already exist</div>
                                       :null
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="degreehead">Description</label>
                                    <input type="text" className="form-control bg-dark dark-theme showtext" value={description} onChange={e => {setDescription(e.target.value)}} placeholder="Enter the Description" id="name"></input>
                                </div>
                                <div className="form-group">
                                    <label className="degreehead">Status</label>
                                        <select  value={status} onChange={e => {setStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                <option >Select Status</option>
                                                <option>ACTIVE</option>
                                                <option>INACTIVE</option>
                                                <option>DELETED</option>
                                            
                                        </select>
                                </div>
                                <div className="form-group">
                                    <label className="degreehead">Show in directory</label>
                                        <select  value={publicvalue} onChange={e => {setPublicvalue(e.target.value)}} type="" class="form-control bg-dark" id="state">
                                                <option >Select </option>
                                                <option>NO</option>
                                                <option>YES</option>
                                                
                                            
                                        </select>
                                </div>
                                <h6 style={{color: "red"}}>* Required Fields</h6>
                                <div className="form-group text-right">
                                    <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                    <button onClick={onFormClick} className="btn btn-primary btn-gisa" type="button">Create</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </form>


                </div>
            </aside>
        </div>
    )
}

export default AddFacultyPosition;